import { FloatClasses, FloatResponsive } from "../../../../src/examples/utilities/Float";
import * as React from 'react';
export default {
  FloatClasses,
  FloatResponsive,
  React
};